import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "aos/dist/aos.css";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import TentangKami from "./pages/TentangKami";
import HubungiKami from "./pages/HubungiKami";
import AplikasiPhoenix from "./pages/AplikasiPhoenix";
import OnlineOffline from "./pages/OnlineOffline";
import Outsourcing from "./pages/Outsourcing";
import WhatsappApi from "./pages/WhatsappApi";
import Event from "./pages/Event";

import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tentang-kami" element={<TentangKami />} />
          <Route path="/hubungi-kami" element={<HubungiKami />} />
          <Route path="/aplikasi-phoenix" element={<AplikasiPhoenix />} />
          <Route path="/outsourcing" element={<Outsourcing />} />
          <Route
            path="/online-offline-distribution"
            element={<OnlineOffline />}
          />
          <Route path="/whatsapp-api" element={<WhatsappApi />} />
          <Route path="/eventMice" element={<Event />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
